import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ShipmentsProvider } from '@prlw/core/shipments/shipments.provider';
import { Shipment } from '@prlw/core/shipments/shipment.entity';

export type ShipmentFlat = Omit<Shipment, 'plants'> & { plants: string };

@Component({
  selector: 'prlw-table-basis-overlay',
  templateUrl: './basis-overlay.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisOverlayContainer {
  @Output() public readonly closeOverlay = new EventEmitter<void>();
  public unselectedShipments$: Observable<ShipmentFlat[]>;

  constructor(private readonly shipmentsProvider: ShipmentsProvider) {
    this.unselectedShipments$ = this._unselectedShipments$;
  }

  public addShipment(shipmentCode: string): void {
    this.shipmentsProvider.addShipmentForCurrentProductGroup(shipmentCode);
  }

  public addAllShipments(): void {
    this.shipmentsProvider.setAllShipmentsForCurrentProductGroup();
    this.closeOverlay.emit();
  }

  private get _unselectedShipments$(): Observable<ShipmentFlat[]> {
    return this.shipmentsProvider.unselectedShipmentsForCurrentProductGroup$.pipe(
      map((shipments) =>
        shipments.map((shipment) => ({
          ...shipment,
          plants: shipment.plants.map((plant) => plant.name).join(', '),
        })),
      ),
    );
  }
}
